export default [
  {
    id: 1,
    type: 'classic-multiple',
    title: 'Выбери все верные утверждения про искусственный интеллект (ИИ)',
    answers: [
      'ИИ обучается на большом количестве точных данных',
      'ИИ создал таблицу Менделеева',
      'ИИ помогает человеку анализировать большой объем информации и принимать решения',
    ],
    rightAnswer: '13',
  },
  {
    id: 2,
    type: 'dnd-list',
    title: 'Определи порядок действий, который позволит обучить ИИ (искусственный интеллект)',
    answers: [
      'Запустить процесс обучения ИИ',
      'Проверить полученный результат',
      'Провести исследование на множестве данных',
      'Внести данные в систему',
    ],
    rightAnswer: '3412',
  },
  {
    id: 3,
    type: 'classic',
    title: 'Выбери верное утверждение:',
    answers: [
      'Структура вещества определяет его свойства',
      'Свойства вещества определяют его структуру',
      'Свойства и структура вещества не связаны друг с другом',
    ],
    rightAnswer: 1,
  },
  {
    id: 4,
    type: 'dnd-compare',
    title: 'Определи класс соединения. Соедини вещество из левого столбца с нужным классом в правом столбце.',
    leftBlocks: [
      'Au',
      'Ag<sub>2</sub>O',
      'AgCI',
      'HCI',
      'KOH',
    ],
    rightBlocks: [
      'Соль',
      'Основание',
      'Оксид',
      'Простое вещество',
      'Кислота',
    ],
  },
]
